import {createStyles, WithStyles} from '@material-ui/core';

export const styles = () => createStyles({
    TableCell: {
        paddingRight: '0'
    },
    editorWrapper: {
        maxWidth: 500
    }
});

export type Classes = WithStyles<typeof styles>
